/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

/**
 * @description Preferences extracted and saved
 */
export const extractPreferences201Schema = z.object({
    "preferences": z.object({
    "userVertical": z.nullable(z.string()),
"sections": z.array(z.object({
    "name": z.string(),
"statements": z.array(z.string())
    }))
    })
    })

/**
 * @description Invalid body, anything other than exactly one of text and audio sent, or audio that is not webm or mp4
 */
export const extractPreferences400Schema = z.any()

/**
 * @description User not found
 */
export const extractPreferences404Schema = z.any()

export const extractPreferencesMutationRequestSchema = z.object({
    "text": z.optional(z.string().describe("The description, typed.")),
"audio": z.optional(z.instanceof(File).describe("The description, recorded. Up to a few minutes; webm or mp4."))
    })

export const extractPreferencesMutationResponseSchema = z.lazy(() => extractPreferences201Schema)